import { H2 } from 'foundations-components/transitional/components/H2';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { ApprovalModalHeaderI18n } from '../i18n/ApprovalModalHeaderI18n';
import { ReleaseBadge } from '../common/ReleaseBadge';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ApprovalModalHeader = ({
  approvalType,
  approvalOperation,
  onCancel
}) => /*#__PURE__*/_jsxs(DialogHeader, {
  children: [/*#__PURE__*/_jsxs(H2, {
    display: "flex",
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(ApprovalModalHeaderI18n, {
      approvalType: approvalType,
      approvalOperation: approvalOperation
    }), /*#__PURE__*/_jsx(ReleaseBadge, {
      approvalType: approvalType
    })]
  }), /*#__PURE__*/_jsx(DialogCloseButton, {
    "data-test-id": "approval-modal-close",
    onClick: onCancel
  })]
});